import { render, staticRenderFns } from "./my-pages-title.vue?vue&type=template&id=802177c8&"
import script from "./my-pages-title.vue?vue&type=script&lang=js&"
export * from "./my-pages-title.vue?vue&type=script&lang=js&"
import style0 from "./my-pages-title.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports